import React from 'react';
import { Contact, Footer } from '../components'
import 'react-toastify/dist/ReactToastify.css';
import Gallery from '../components/Gallery';
import Meta from '../components/common/Meta';
import image from '../assets/images/services/services-header.jpg';



export const GalleryPage = () => {

  return (
    <div>
    <Meta
    title="Gallery | Architectural & Construction Designs Rwanda"
    description="Visual gallery of architectural designs, interiors, landscaping, and construction projects completed by Edges Design Group."
    keywords="
      Green & Sustainable Architecture | Rwanda & Africa,
      Architectural design Rwanda,
      Modern house design Rwanda,
      Residential building design,
      Commercial architecture services,
      Interior design Rwanda,
      Interior finishing works Kigali,
      Modern interiors,
      Residential interior solutions,
      Landscaping design Rwanda,
      Garden design Kigali,
      Exterior landscaping services,
      Ibishushanyo mbonera,
      Inzu,
      Green building design Rwanda,
      Sustainable architecture Africa,
      Sustainable architecture Kigali,
      Energy-efficient building design,
      Environmental design consulting,
      Architecture durable Rwanda,
      Conception de bâtiments écologiques,
      Inzu zibungabunga ibidukikije,
      Kubaka hadatakaye ingufu"
      />

      <header
        className="relative min-h-[320px] flex items-center justify-center bg-cover bg-center"
        style={{ backgroundImage: `url(${image})` }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>
        <div className="relative text-center px-4 z-10">
          <h1 className="text-4xl md:text-5xl font-extrabold text-white uppercase tracking-wide">
            Our Gallery
          </h1>
          <p className="mt-4 text-lg md:text-xl text-gray-200 max-w-2xl mx-auto">
            A visual journey through our architectural designs, interiors, and completed projects.
          </p>
        </div>
      </header>

      <Gallery/>
      <Contact />
      <div className=' w-full h-1 bg-gray-400'></div>
      <Footer />
    </div>
  )
}

export default GalleryPage
